let names = [
    'Btn',
    'Login',
    'Cover',
    'Dialog',
    'DialogBaseInput',
    'DialogInput',
    'About',
    'NavCell',
    'ProductinDiaLog',
    'Productinformation',
    'gameRateStar',
    'CarouselInfo',
    'AboutDialog',
    'elementButton',
    'textButtonGroup',
    'searchForm',
    'DialogForm',
    'trainStar',
    'AdmNavCell',
    'searchFormNew',
    'RetrievePassword',
    'gameIntroduceTabs',
    'gameIntroduceCard',
    'ageRangeSelect',
    'operationDialog',
    'CheckedItem'
]
export default {
    install(Vue) {
        names.forEach(name => {
            Vue.component(name, require(`./vision/${name}.vue`).default)
        })
    }
}


//////////////////
// WEBPACK FOOTER
// ./yotta-vue-components/vision-ui-plugin.js
// module id = null
// module chunks = 